export default __webpack_public_path__ + "static/media/facebook.3feb7099.png";